package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_07_14_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-07-14")
@Composable
public fun Log_2023_07_14(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "The Whirlpool's Grasp",
        ogTitle = "The Whirlpool's Grasp",
        date = LocalDate(2_023, 7, 14),
        ogDescription = "Disaster strikes as the boats capsize in a magical whirlpool, and grasping tendrils drag the heroes into the water.",
        ogImage = "ai/2023-07-14.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-31", dateString = "Newgrowth 31")
        Log_2023_07_14_Day_1()
    }
}
